import * as XLSX from 'xlsx';

export const downloadChatIdsXls = idsArray => {
    if (Array.isArray(idsArray)) {
        const data = [['chat_id'], ...idsArray.map(num => [num])];

        const ws = XLSX.utils.aoa_to_sheet(data);
        ws['!cols'] = [
            { wpx: 200 }, // ширина первой колонки
        ];

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Numbers');

        XLSX.writeFile(wb, 'telegramIds.xls');
    }
};
